import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getSession, isSessionDirty } from "../store/session/queries";
import { useAuth0 } from "@auth0/auth0-react";
import { cleanUpSessionStorage } from "../lib/utils";

const useSession = () => {
  const history = useHistory();
  const dirtySession = useSelector(isSessionDirty());
  const session = useSelector(getSession());
  const { logout } = useAuth0();
  if (dirtySession) {
    cleanUpSessionStorage();
    logout({ logoutParams: { returnTo: window.location.origin } });
    history.push("/");
  }
  return session;
};

export default useSession;
